import React, { useEffect, useState, useContext } from "react";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import Pagination from "../../components/Pagination";
import ConfirmModal from "../../components/ConfirmModal";
import EditCustomer from "./EditCustomer";
import AddCustomer from "./AddCustomer";
import ViewCustomerModal from "./ViewCustomerModal";
import BroadcastModal from "./BroadcastModal";
import loader from "../../assets/loader.webp";
import { ProfileDetailsContext } from "../../context/ProfileDetailsProvider";

import { fetchData, deleteData, getDataById } from "../../utility/adminApi";

function Customers() {
  const { profileDetails } = useContext(ProfileDetailsContext);
  const [customerData, setCustomerData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [addtab, setAddtab] = useState(false);
  const [edittab, setEdittab] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [isPrevLoading, setIsPrevLoading] = useState(false);
  const [isNextLoading, setIsNextLoading] = useState(false);

  const [singleData, setSingleData] = useState({});
  const [customerToDelete, setCustomerToDelete] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [viewCustomerData, setViewCustomerData] = useState(null);
  const [isBroadcastModalOpen, setIsBroadcastModalOpen] = useState(false);

  const [searchData, setSearchData] = useState("");

  const handleChange = async (e) => {
    setSearchData(e.target.value);
  };

  const fetchCustomers = async (page = 1, search = "") => {
    const response = await fetchData("customers", currentPage, searchData);
    setCustomerData(response?.data || []);

    // Check localStorage if action is "add" then setIsModalOpen(true)
    const action = localStorage.getItem("action");
    if (action === "add") {
      setAddtab(true);
      // Optionally clear the action after using it
      localStorage.removeItem("action");
    }

    setTotalPage(response?.data?.last_page);
    setIsLoading(false);
    setIsNextLoading(false);
    setIsPrevLoading(false);
  };

  // Fetch data on page change or search query change
  useEffect(() => {
    fetchCustomers(currentPage, searchData);
    // fetchProfileData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);
  useEffect(() => {
    setCurrentPage(1);
    fetchCustomers(currentPage, searchData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData]);

  // Check subscription plan (for debugging)
  useEffect(() => {
    console.log(profileDetails);
  }, [profileDetails]);

  // Handle broadcast button click - check plan first
  const handleBroadcastClick = () => {
      // Allow broadcast
      setIsBroadcastModalOpen(true);
  };

  const handleCurrentPage = (page) => {
    setCurrentPage(page);
  };

  const handleAdd = () => {
    setAddtab(true);
    setEdittab(false);
  };

  const handleSingleFile = async (id, setEditTab = false) => {
    const response = await getDataById("customers/show/", id);
    setSingleData(response?.data?.data);
    if (setEditTab) {
      setEdittab(true);
    } else {
      // setViewFile(true)
    }
  };

  const handleView = async (id) => {
    const response = await getDataById("customers/show/", id);
    setViewCustomerData(response?.data?.data);
    setIsViewModalOpen(true);
  };

  const handleCloseViewModal = () => {
    setIsViewModalOpen(false);
    setViewCustomerData(null);
  };

  const handleDelete = (id) => {
    setCustomerToDelete(id);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  const handleConfirmDelete = async () => {
    await deleteData("customers/delete/", customerToDelete);
    fetchCustomers(currentPage); //
    setIsModalOpen(false);
  };

  return (
    <div className=" lg:overflow-y-hidden ">
      {/* Header */}
      <div className="flex flex-col lg:flex-row justify-between  items-center p-4 w-full">
        <h3 className="text-xl font-semibold">
          {" "}
          <PermIdentityIcon /> Customers
        </h3>
        <div className="flex gap-6">
          <button
            onClick={() => {
              handleAdd();
            }}
            className="p-3 rounded-lg text-white bg-gray-500"
          >
            Add Customer <AddIcon />
          </button>
          <button
            className="p-3 rounded-lg text-white bg-green-600 hover:bg-green-700"
            onClick={handleBroadcastClick}
          >
            Broadcast
          </button>
        </div>
      </div>
      {addtab && !edittab && (
        <AddCustomer
          setIsLoading={setIsLoading}
          setAddtab={setAddtab}
          fetchCustomers={fetchCustomers}
          currentPage={currentPage}
        />
      )}
      {edittab && !addtab && (
        <EditCustomer
          singleData={singleData}
          setSingleData={setSingleData}
          setEdittab={setEdittab}
          setLoading={setIsLoading}
          currentPage={currentPage}
          fetchCustomers={fetchCustomers}
        />
      )}

      {!edittab && !addtab && (
        <div className="w-full p-4 flex flex-col gap-2 bg-white">
          <input
            placeholder="Search for customer"
            type="text"
            name="customer_name"
            value={searchData}
            onChange={handleChange}
            className="border-2 border-gray-400 w-60 p-2 px-6"
          />
          <div className="w-full">
            {isLoading ? (
              <div className="  flex justify-center items-center">
                <img
                  src={loader}
                  alt="loader"
                  className=" w-10 lg:w-20 "
                />
              </div>
            ) : (
              <table className="min-w-full bg-white border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="py-2 px-4 border-b border-gray-300">Name</th>
                    <th className="py-2 px-4 border-b border-gray-300">
                      Email / Phone Number
                    </th>
                    {/* <th className="py-2 px-4 border-b border-gray-300">
                      Discount
                    </th> */}
                    <th className="py-2 px-4 border-b border-gray-300 text-wrap">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {customerData && customerData.map((item) => (
                    <tr
                      key={item?.id}
                      className="hover:bg-gray-100 border-b border-gray-300"
                    >
                      <td className="py-2 px-4 text-wrap text-center">
                        {item?.name}
                      </td>
                      <td className="py-2 px-4 text-center text-wrap">
                        {item?.email
                          ? item.email
                          : item?.phone_number
                          ? item.phone_number
                          : item?.preference
                          ? item.preference
                          : "N/A"}
                      </td>
                      {/* <td className="py-2 px-4 text-center text-wrap">
                        {item?.discount ? item.discount : "N/A"}
                      </td> */}
                      <td className="py-2 px-4 flex justify-center gap-3">
                        <VisibilityIcon
                          onClick={() => handleView(item?.id)}
                          className="text-yellow-400 cursor-pointer"
                          title="View Customer Details"
                        />
                        <EditIcon
                          onClick={() => handleSingleFile(item?.id, true)}
                          className="text-blue-500 cursor-pointer"
                          title="Edit Customer"
                        />
                        <DeleteIcon
                          onClick={() => handleDelete(item?.id)}
                          className="text-red-500 cursor-pointer"
                          title="Delete Customer"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          <Pagination
            onPageChange={handleCurrentPage}
            totalPage={totalPage}
            currentPage={currentPage}
            setIsNextLoading={setIsNextLoading}
            setIsPrevLoading={setIsPrevLoading}
            isPrevLoading={isPrevLoading}
            isNextLoading={isNextLoading}
          />
        </div>
      )}
      <ConfirmModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
        text1="Confirm Delete"
        text2="Are you sure you want to delete the customer?"
      />
      <ViewCustomerModal
        isOpen={isViewModalOpen}
        onClose={handleCloseViewModal}
        customer={viewCustomerData}
      />
      <BroadcastModal
        isOpen={isBroadcastModalOpen}
        onClose={() => setIsBroadcastModalOpen(false)}
        customers={customerData}
      />
    </div>
  );
}

export default Customers;